<template>

    <div class="page-container">

        <header-band
            :back="true"
            :blueCleanfox="true"
            :title="$t('login_email_web_header')"
            @eventBack="eventBack"
        ></header-band>

        <email-redirect></email-redirect>

    </div>

</template>

<script>
import UserFlow from '@/modules/userFlow'

import HeaderBand from '@/components/headers/HeaderBand'
import InputText from '@/components/inputs/InputText'
import EmailRedirect from '@/components/loginFlow/EmailRedirect.vue'

import ModalErrorProvider from '@/components/modal/ModalErrorProvider'
import Toast from '@/components/Toast'


export default {

    name: 'login-email',

    components: {HeaderBand, InputText, EmailRedirect, ModalErrorProvider, Toast},


    created() {

        UserFlow.setPage(this, 'login_email')

    },

    methods: {

        eventBack() {

            this.$router.push({path: '/'})
        }

    }
}
</script>

<style lang="scss" scoped>

.page-container {
    width: 100%;
    min-height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }
}

</style>
